import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, OnDestroy, HostBinding
} from '@angular/core';

import {
  DOCUMENT
} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import {
  LoginDialogComponent
} from './components/login-dialog/login-dialog.component';
import {ApiService} from '../services/api';
import {BrandService} from '../services/brand-service/brand.service';
import {HttpParams} from '@angular/common/http';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';

@Component({
  selector: 'app-login',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'login.template.html',
  styleUrls: [
    './login.style.scss'
  ]
})

export class LoginComponent {
  @HostBinding('style.background') public backgroundStyle:SafeStyle;
  branding:any;


  constructor(public dialog: MatDialog,
              private api:ApiService,
              private sanitizer: DomSanitizer,
              private brandService:BrandService) {

    // Ask for shipping information
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      width: '300px',
      hasBackdrop: false,
      closeOnNavigation: false
    });


    const params = new HttpParams().set('domain', document.location.hostname.toLowerCase());

    this.api.get<any>(`/brand`, params)
      .subscribe(branding => {
        if( branding ) {
          this.branding = branding;
          console.log("Received branding: " + JSON.stringify(branding) + " " + this.branding.primary_color);
          this.brandService.next(this.branding);
          this.backgroundStyle = this.sanitizer.bypassSecurityTrustStyle(`radial-gradient(ellipse at center, ${this.branding.primary_color} 0%, ${this.branding.alternate_color} 100%)`);
        }
      });
  }

}
